import { useEffect, useRef } from 'react';
import { useQueryClient } from '@tanstack/react-query';

import { setCurrentUserTimezone } from '@/lib/api/generated/api';

import { notificationKeys } from '../queryKeys';
import { usePreferences } from './usePreferences';

/**
 * Tells the service the browser's time zone (spec 134 US2), so the morning
 * digest arrives at 08:00 local time. Once per session, after the stored zone
 * is known, and only when the two differ. Nothing is shown; a refusal is left
 * for the next session to try again.
 */
export function useReportTimezone(): void {
  const { preferences } = usePreferences();
  const queryClient = useQueryClient();
  const sent = useRef(false);
  useEffect(() => {
    if (sent.current || !preferences) return;
    const browser = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (!browser || preferences.timezone === browser) return;
    sent.current = true;
    void setCurrentUserTimezone({ timezone: browser }).then((response) => {
      if (response.status === 200) {
        void queryClient.invalidateQueries({
          queryKey: notificationKeys.preferences(),
        });
      }
    });
  }, [preferences, queryClient]);
}
